"use client";

import SiteNav from "@/components/SiteNav";
import Catalog from "@/components/pages/Catalog";

export default function CataloguePage() {
  return (
    <>
      <SiteNav />
      <Catalog />
    </>
  );
}
